import React from 'react';

import { Result } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TYPE_CONFIG = {
    error: {
        icon: byPrefixAndName.fass['bomb'],
        iconProps: { danger: true, bounce: true },
        title: 'Error',
        iconSize: '4rem',
        iconSizeFullPage: '6rem',
        defaultSubtitle: (
            <p>
                We're sorry — an unexpected error occurred.
                <br />
                Please retry, and contact support if it persists.
                <br />
                Thank you for your understanding.
            </p>
        ),
    },
    building: {
        icon: byPrefixAndName.fasl['computer-classic'],
        iconProps: {},
        title: 'Coming soon',
        iconSize: '5rem',
        iconSizeFullPage: '10rem',
        iconOpacity: 0.5,
        defaultSubtitle: (
            <p>
                Sorry, this feature is currently under development.
                <br />
                It will be ready soon!
            </p>
        ),
    },
    warning: {
        icon: byPrefixAndName.fass['triangle-exclamation'],
        iconProps: { warning: true },
        title: 'Warning',
        iconSize: '4rem',
        iconSizeFullPage: '6rem',
    },
    'not-allowed': {
        icon: byPrefixAndName.fass['ban'],
        iconProps: { danger: true, bounce: true },
        title: 'Invalid Access',
        iconSize: '5rem',
        iconSizeFullPage: '10rem',
        defaultSubtitle: (
            <p>
                We're sorry, but your current Netwalk user policies do not permit this operation.
                <br />
                Please contact your administrator if you believe this is an error or need further assistance.
                <br />
                <br />
                Thank you for your understanding.
            </p>
        ),
    },
};

const ResultContainer = styled.div`
    .ant-result-icon {
        font-size: ${(props) => props.$iconSize};
        ${(props) => props.$iconOpacity && `opacity: ${props.$iconOpacity};`}
    }

    .ant-result-subtitle {
        color: ${(props) => props.theme.TextColor};
        font-size: 1rem;

        p {
            max-width: 30rem;
            margin: 0 auto;
        }
    }

    &.full-page {
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 4rem);
        background-color: ${(props) => props.theme.BackgroundColorLight};

        .ant-result-icon {
            font-size: ${(props) => props.$iconSizeFullPage};
            ${(props) => props.$iconOpacity && `opacity: ${props.$iconOpacity};`}
        }
    }
`;

const SystemMessage = ({ type = 'error', fullPage, text, details }) => {
    const config = TYPE_CONFIG[type] || TYPE_CONFIG.error;

    const subtitle = (
        <>
            {text ? <p>{text}</p> : config.defaultSubtitle}
            {details && (
                <p style={{ marginTop: '1rem' }} className="nw-code-block">
                    {details}
                </p>
            )}
        </>
    );

    return (
        <ResultContainer
            className={fullPage ? 'full-page' : ''}
            $iconSize={config.iconSize}
            $iconSizeFullPage={config.iconSizeFullPage}
            $iconOpacity={config.iconOpacity}
        >
            <Result
                icon={<NwIcon {...config.iconProps} icon={config.icon} />}
                title={config.title}
                subTitle={subtitle}
            />
        </ResultContainer>
    );
};

export default SystemMessage;
